import { BottomSheetBackdrop, BottomSheetModal, BottomSheetView, useBottomSheetModal } from '@gorhom/bottom-sheet'
import React, { createRef, useCallback, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Platform, StyleSheet } from 'react-native'
import { styles } from './styles'
import { ReduceMotion } from 'react-native-reanimated'
import { DS } from '../../design-system'
import { useStore } from '../../models'
import { useMaxWidth } from '@/components/WebWrapper'
import { api } from '@ppwr/convex/_generated/api'
import { useMutation } from 'convex/react'

const isWeb = Platform.OS === 'web'

export const deleteAccountSheetModal = createRef<BottomSheetModal>()

export const DeleteAccountSheetModal = observer(() => {
  const maxWidth = useMaxWidth()

  const {
    session: { user, deleteAccount, logout }
  } = useStore()

  const { dismissAll } = useBottomSheetModal()
  const deleteAvatarPreferences = useMutation(api.avatarPreferences.mutations.deleteAvatarPreferences)

  const snapPoints = ['40%']

  const [loading, setLoading] = useState(false)

  const onPressConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const userId = user?._id
      if (userId) {
        if (user?.auth0Id) {
          await deleteAvatarPreferences({ userId: user.auth0Id })
        }
        await deleteAccount()
        logout()
        // navigation.navigate(RootRoutes.auth)
      }
    } catch (error) {
      console.log('LOG: > onPressConfirm > error:', error)
    } finally {
      setLoading(false)
      dismissAll()
    }
  }, [user, deleteAccount, deleteAvatarPreferences, logout, dismissAll])

  const onPressCancel = useCallback(() => {
    dismissAll()
  }, [dismissAll])

  return (
    <BottomSheetModal
      ref={deleteAccountSheetModal}
      name="delete-account"
      overrideReduceMotion={ReduceMotion.System}
      index={0}
      // snapPoints={snapPoints}
      enableDynamicSizing={true}
      backdropComponent={(props) => <BottomSheetBackdrop {...props} disappearsOnIndex={-1} appearsOnIndex={0} />}
      handleStyle={styles.bottomSheetHandleStyle}
      handleIndicatorStyle={styles.bottomSheetIndicatorStyle}
      backgroundStyle={{ backgroundColor: DS.palette['Brand/Cream'] }}
      style={{
        marginHorizontal: isWeb ? 'auto' : undefined,
        maxWidth: maxWidth,
        width: '100%'
      }}
    >
      <BottomSheetView style={isWeb ? {} : { flex: 1 }}>
        <DS.Frame gap="24" alignItems="center" flex={1} style={otherStyles.container}>
          <DS.Frame gap="4">
            <DS.Text textAlign="center" variant="Heading 2/Medium">
              Are you sure you want to delete your account?
            </DS.Text>
          </DS.Frame>
          <DS.Frame gap="8">
            <DS.Button
              onPress={onPressConfirm}
              style={otherStyles.btn}
              variant="Large/Primary"
              type="On Light"
              disabled={loading}
            >
              Yes
            </DS.Button>
            <DS.Button onPress={onPressCancel} style={otherStyles.btn} variant="Large/Secondary" type="On Dark">
              No
            </DS.Button>
          </DS.Frame>
        </DS.Frame>
      </BottomSheetView>
    </BottomSheetModal>
  )
})

const otherStyles = StyleSheet.create({
  container: {
    padding: DS.spacing[24],
    paddingTop: DS.spacing[8]
  },
  btn: {
    width: '100%',
    minWidth: 250
  }
})
